import React from 'react'
import { Link } from 'gatsby'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'

import { Icon, Box } from '../components/common'
import { Layout } from '../components/common/layout'
import { HomeHeader } from '../components/home'
import { Spirit } from '../styles/spirit-styles'
import { MetaData, getMetaImageUrls } from '../components/common/meta'

import Stepper from 'react-stepper-horizontal'

/*
import { init as initApm } from '@elastic/apm-rum'
*/

const HomePage = ({ data, location }) => {
    // Add meta title and description for this page here to overwrite the site meta data as set in the config
    const title = `SDC Toolkits for Product Plan `
    const description = `SDC Toolkits for Product Plan`
    const imageUrl = getMetaImageUrls()
    const { steps } = {
        steps: [{
            title: `要卖给谁?`,
            href: `concepts/Who_are_you_selling_to_zh_CN`,
        }, {
            title: `卖的是什么?`,
            href: `concepts/What_are_you_selling_zh_CN`,
        }, {
            title: `有何价值?`,
            href: `concepts/What_value_do_you_provide_your_customers_zh_CN`,
        }, {
            title: `如何定价?`,
            href: `concepts/How_will_you_price_your_product_zh_CN`,
        }, {
            title: `如何分发?`,
            href: `concepts/How_will_you_distribute_your_product_zh_CN`,
        }],
        currentStep: 0,
    }

    return (
        <>
            <MetaData
                data={data}
                location={location}
                type="website"
                title={title}
                description={description}
                image={imageUrl}
            />
            <Layout
                headerDividerStyle="shadow"
                bodyClass="bg-white"
                mainClass="bg-whitegrey-l2 pb-vw6 pb-vw3-ns"
                header={<HomeHeader/>}
            >
                <div className="pt-vw3 home-main-box-padding-ns">
                    <section className={`${Spirit.page.xl} col-12 mt2 mt-vw1-ns bt bn-ns b--whitegrey pt2 pt0-ns`}>
                        <Link to="concepts/product-strategy-setting-your-strategic-vision-for-product-offerings_zh_CN"
                            className={`${Spirit.h3} link darkgrey hover-midgrey`}>产品企划要素</Link>
                        <p className={`${Spirit.p} mt2 midgrey flex flex-column flex-row-ns justify-between items-center-ns`}>
                            当定义产品策略时，要明确已回答了如下问题。
                        </p>
                        <div>
                            <Stepper
                                steps={steps}
                                size={48}
                                activeStep={5}
                                circleFontSize={16}
                                defaultBorderWidth={6}
                                completeColor={`#AD56B4`}
                                completeBarColor={`#AD56B4`}
                                lineMarginOffset={0}/>
                        </div>
                    </section>

                    {/*<section className={`${Spirit.page.xl} col-12 mt8 mt-vw3-ns bt bn-ns b--whitegrey pt5 pt0-ns`}>*/}
                    {/*    <Link to="#" className={`${Spirit.h3} link darkgrey hover-midgrey`}>指南</Link>*/}

                    {/*    <p className={`${Spirit.p} mt2 midgrey flex flex-column flex-row-ns justify-between items-center-ns`}>*/}
                    {/*        产品企划涉及到很多相关的主题，如：策略、市场营销、销售等。*/}
                    {/*        <Link to="#" className="blue link din nb1 mt2 mt0-ns hover-underline-blue">*/}
                    {/*            <span className="flex items-center fw5">了解更多指南文档<Icon name="arrow-right"*/}
                    {/*                className="w3 h3 ml1 fill-blue"/></span>*/}
                    {/*        </Link>*/}
                    {/*    </p>*/}
                    {/*    <div className="grid-integrations-index mt4 mt6-l f8">*/}
                    {/*        <Box to="#"*/}
                    {/*            className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc"*/}
                    {/*            elevation="2" radius="4">*/}
                    {/*            <Icon name={`blocks`} className={`w10 h-auto w12-ns stroke-w--1-5 mb2 stroke-blue`}/>*/}
                    {/*            策略*/}
                    {/*        </Box>*/}
                    {/*        <Box to="#"*/}
                    {/*            className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc"*/}
                    {/*            elevation="2" radius="4">*/}
                    {/*            <Icon name={`blocks`} className={`w10 h-auto w12-ns stroke-w--1-5 mb2 stroke-blue`}/>*/}
                    {/*            市场营销*/}
                    {/*        </Box>*/}
                    {/*        <Box to="#"*/}
                    {/*            className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc"*/}
                    {/*            elevation="2" radius="4">*/}
                    {/*            <Icon name={`blocks`} className={`w10 h-auto w12-ns stroke-w--1-5 mb2 stroke-blue`}/>*/}
                    {/*            销售*/}
                    {/*        </Box>*/}
                    {/*        <Box to="#"*/}
                    {/*            className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc"*/}
                    {/*            elevation="2" radius="4">*/}
                    {/*            <Icon name={`blocks`} className={`w10 h-auto w12-ns stroke-w--1-5 mb2 stroke-blue`}/>*/}
                    {/*            产品管理*/}
                    {/*        </Box>*/}
                    {/*        <Box to="#"*/}
                    {/*            className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc"*/}
                    {/*            elevation="2" radius="4">*/}
                    {/*            <Icon name={`blocks`} className={`w10 h-auto w12-ns stroke-w--1-5 mb2 stroke-blue`}/>*/}
                    {/*            产品研发*/}
                    {/*        </Box>*/}
                    {/*        <Box to="#"*/}
                    {/*            className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc"*/}
                    {/*            elevation="2" radius="4">*/}
                    {/*            <Icon name={`blocks`} className={`w10 h-auto w12-ns stroke-w--1-5 mb2 stroke-blue`}/>*/}
                    {/*            其他_1*/}
                    {/*        </Box>*/}
                    {/*        <Box to="#"*/}
                    {/*            className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc"*/}
                    {/*            elevation="2" radius="4">*/}
                    {/*            <Icon name={`blocks`} className={`w10 h-auto w12-ns stroke-w--1-5 mb2 stroke-blue`}/>*/}
                    {/*            其他_2*/}
                    {/*        </Box>*/}
                    {/*        <Box to="#"*/}
                    {/*            className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc"*/}
                    {/*            elevation="2" radius="4">*/}
                    {/*            <Icon name={`blocks`} className={`w10 h-auto w12-ns stroke-w--1-5 mb2 stroke-blue`}/>*/}
                    {/*            其他_3*/}
                    {/*        </Box>*/}
                    {/*        <Box to="#"*/}
                    {/*            className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc"*/}
                    {/*            elevation="2" radius="4">*/}
                    {/*            <Icon name={`blocks`} className={`w10 h-auto w12-ns stroke-w--1-5 mb2 stroke-blue`}/>*/}
                    {/*            其他_4*/}
                    {/*        </Box>*/}
                    {/*        <Box to="#"*/}
                    {/*            className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc"*/}
                    {/*            elevation="2" radius="4">*/}
                    {/*            <Icon name={`blocks`} className={`w10 h-auto w12-ns stroke-w--1-5 mb2 stroke-blue`}/>*/}
                    {/*            其他_5*/}
                    {/*        </Box>*/}
                    {/*        <Box to="#"*/}
                    {/*            className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn"*/}
                    {/*            elevation="2" radius="4">*/}
                    {/*            <Icon name="more" className="w8 nudge-top--6"/>*/}
                    {/*            了解更多*/}
                    {/*        </Box>*/}
                    {/*    </div>*/}
                    {/*</section>*/}

                    <section className={`${Spirit.page.xl} col-12 mt8 mt-vw3-ns bt bn-ns b--whitegrey pt5 pt0-ns`}>
                        <Link to="#" className={`${Spirit.h3} link darkgrey hover-midgrey`}>著作</Link>

                        <p className={`${Spirit.p} mt2 midgrey flex flex-column flex-row-ns justify-between items-center-ns`}>
                            国内外经典图书、教材等。
                            <Link to="#" className="blue link din nb1 mt2 mt0-ns hover-underline-blue">
                                <span className="flex items-center fw5">了解更多著作<Icon name="arrow-right"
                                    className="w3 h3 ml1 fill-blue"/></span>
                            </Link>
                        </p>
                        <div className="grid-integrations-index mt4 mt6-l f8">
                            <Box
                                href="https://wwfalcon.github.io/ebooks_for_sdc/md/mba_qing_song_du_-_shi_chang_ying_xiao/ch001.html"
                                className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc"
                                elevation="2" radius="4">
                                <Icon name={`blocks`} className={`w10 h-auto w12-ns stroke-w--1-5 mb2 stroke-blue`}/>
                                MBA轻松读 - 市场营销，日本商学院
                            </Box>
                            <Box
                                href="https://wwfalcon.github.io/ebooks_for_sdc/md/ke_te_le_-_ying_xiao_guan_li_-_di_13_ban/ch002.html"
                                className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc"
                                elevation="2" radius="4">
                                <Icon name={`blocks`} className={`w10 h-auto w12-ns stroke-w--1-5 mb2 stroke-blue`}/>
                                科特勒《营销管理》(第13版)
                            </Box>
                            <Box href="https://wwfalcon.github.io/ebooks_for_sdc/md/the_fifth_discipline/ch002.html"
                                className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc"
                                elevation="2" radius="4">
                                <Icon name={`blocks`} className={`w10 h-auto w12-ns stroke-w--1-5 mb2 stroke-blue`}/>
                                彼得·圣吉《第五项修炼》
                            </Box>
                            <Box
                                href="https://wwfalcon.github.io/ebooks_for_sdc/md/i_know_what_he_want_to_read/part0000.html"
                                className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc"
                                elevation="2" radius="4">
                                <Icon name={`blocks`} className={`w10 h-auto w12-ns stroke-w--1-5 mb2 stroke-blue`}/>
                                我知道他想看什么 - 用内容营销打造品牌影响力
                            </Box>
                            <Box
                                href="https://wwfalcon.github.io/ebooks_for_sdc/md/focus_the_future_of_your_company_depends_on_it/zuo_zhe_de_hua.html"
                                className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc"
                                elevation="2" radius="4">
                                <Icon name={`blocks`} className={`w10 h-auto w12-ns stroke-w--1-5 mb2 stroke-blue`}/>
                                聚焦：决定你企业的未来
                            </Box>
                            <Box
                                href="https://wwfalcon.github.io/ebooks_for_sdc/md/leananalytics/index.html"
                                className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc"
                                elevation="2" radius="4">
                                <Icon name={`blocks`} className={`w10 h-auto w12-ns stroke-w--1-5 mb2 stroke-blue`}/>
                                精益数据分析
                            </Box>
                            <Box
                                href="https://wwfalcon.github.io/ebooks_for_sdc/md/positioning_in_the_21st_century/index.html"
                                className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc"
                                elevation="2" radius="4">
                                <Icon name={`blocks`} className={`w10 h-auto w12-ns stroke-w--1-5 mb2 stroke-blue`}/>
                                21世纪的定位：定位之父重新定义"定位"
                            </Box>
                            <Box href="sdc_toolkits_page/_book/"
                                className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn"
                                elevation="2" radius="4">
                                <Icon name="more" className="w8 nudge-top--6"/>
                                了解更多
                            </Box>
                        </div>
                    </section>
                    <section className={`${Spirit.page.xl} col-12 mt8 mt-vw3-ns bt bn-ns b--whitegrey pt5 pt0-ns`}>
                        <Link to="#" className={`${Spirit.h3} link darkgrey hover-midgrey`}>快速参考</Link>

                        <p className={`${Spirit.p} mt2 midgrey flex flex-column flex-row-ns justify-between items-center-ns`}>
                            仅保存从互联网公开渠道获取的信息，并利用 gitbook 形态发布，方便浏览及检索。
                            <Link to="#" className="blue link din nb1 mt2 mt0-ns hover-underline-blue">
                                <span className="flex items-center fw5">了解更多著作<Icon name="arrow-right"
                                                                                    className="w3 h3 ml1 fill-blue"/></span>
                            </Link>
                        </p>
                        <div className="grid-integrations-index mt4 mt6-l f8">
                            <Box
                                href="https://wwfalcon.github.io/fastref_for_sdc/md/china_telcom_opt/"
                                className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc"
                                elevation="2" radius="4">
                                <Icon name={`blocks`} className={`w10 h-auto w12-ns stroke-w--1-5 mb2 stroke-blue`}/>
                                中国电信运营商组织机构
                            </Box>

                            <Box href="sdc_toolkits_page/_book/"
                                 className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn"
                                 elevation="2" radius="4">
                                <Icon name="more" className="w8 nudge-top--6"/>
                                了解更多
                            </Box>
                        </div>
                    </section>

                </div>

            </Layout>

        </>

    )
}

HomePage.propTypes = {
    data: PropTypes.shape({
        site: PropTypes.shape({
            siteMetadata: PropTypes.shape({
                siteUrl: PropTypes.string.isRequired,
                title: PropTypes.string.isRequired,
                description: PropTypes.string.isRequired,
            }).isRequired,
        }).isRequired,
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
}

export default HomePage

export const pageQuery = graphql`
    query {
        site {
            ...SiteMetaFields
        }
    }
`
